export default process.env.NODE_ENV !== "production"
  ? // export default false
    {
      node_api_endpoint: "https://kycapi.escrowstack.io",
      // node_api_endpoint: "http://192.168.0.196:5050",
      // kyc_api_endpoint: "http://192.168.0.196:5051",
      // kyc_api_endpoint: "http://192.168.0.196:5051",
      kyc_api_endpoint: "https://kyc.getcupi.com/api",
      // node_api_endpoint: "http://192.168.1.193:5050",
      // kyc_api_endpoint: "http://192.168.0.95:5051",
      // kyc_api_endpoint: "http://192.168.1.193:5051",
      cognito_client_id: "6oign0d7urm10jstpl9r9crt25",
      Client_Id: "21k0cgope0hvi22dikd805pbes",
      // cognito_client_id: "3g6r2ulh1m5jqisc8eajo47vv7",
    }
  : {
      node_api_endpoint: "http://192.168.0.196:5050",
      kyc_api_endpoint: "https://kyc.getcupi.com/api",
      cognito_client_id: "6oign0d7urm10jstpl9r9crt25",
      Client_Id: "21k0cgope0hvi22dikd805pbes",
    };
